/*
|--------------------------------------------------------------------------
| Views: Section Basic
|--------------------------------------------------------------------------
*/

/**
 * Section Basic
 * @namespace
 */
__gh__webApp.views.sectionBasic = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){
		__gh__webApp.utilities.infiniteScroll.init();
	},

	"getSubView": function(bucket){
		// Prep Items
		bucket.view.name 					= "buckets/sectionBasic/default";
		bucket.view.infiniteScroll.view		= "buckets/sectionBasic/partials/_infinite";
		return bucket;

	}
};